import { FaSun, FaRegSun, FaMoon, FaRegMoon } from "react-icons/fa";
import { useThemeMode, useSetThemeMode } from "../../context/theme";
import { ButtonToggleGroup, ButtonToggle } from "../components/ToggleButton";
import { isMobile } from "../../shared/hooks";

export const ModeToggle = () => {
  const mode = useThemeMode();
  const setMode = useSetThemeMode();

  const iconClass = "w-[15px] h-[15px] shrink-0 aspect-square";
  const buttonClass = "data-[active=false]:bg-transparent";

  if (isMobile) {
    return (
      <div className="flex flex-col gap-2 w-full">
        <div className="text-foreground-muted text-[length:var(--Font-Size-sm,10.5px)]">
          Mobile devices use your system theme preference
        </div>
        <ButtonToggleGroup className="flex p-[2px] justify-center items-center gap-1.5 rounded-md border border-outline bg-card opacity-50 pointer-events-none">
          <ButtonToggle className={buttonClass} data-active={mode === "light"}>
            {mode === "light" ? <FaSun className={iconClass} /> : <FaRegSun className={iconClass} />}
          </ButtonToggle>
          <ButtonToggle className={buttonClass} data-active={mode === "dark"}>
            {mode === "dark" ? <FaMoon className={iconClass} /> : <FaRegMoon className={iconClass} />}
          </ButtonToggle>
        </ButtonToggleGroup>
      </div>
    );
  }

  return (
    <ButtonToggleGroup className="flex p-[2px] justify-center items-center gap-1.5 rounded-md border border-outline bg-card">
      <ButtonToggle className={buttonClass} onClick={() => setMode("light")} data-active={mode === "light"}>
        {mode === "light" ? <FaSun className={iconClass} /> : <FaRegSun className={iconClass} />}
      </ButtonToggle>
      <ButtonToggle className={buttonClass} onClick={() => setMode("dark")} data-active={mode === "dark"}>
        {mode === "dark" ? <FaMoon className={iconClass} /> : <FaRegMoon className={iconClass} />}
      </ButtonToggle>
    </ButtonToggleGroup>
  );
};
